// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableCellLink__link__1fHz5{color:var(--font-color);cursor:pointer;font-size:.875rem;line-height:1.125rem}", "",{"version":3,"sources":["webpack://./src/common/components/Table/components/TableCellLink/TableCellLink.css"],"names":[],"mappings":"AAAA,4BAEE,uBAAwB,CAExB,cAAe,CAHf,iBAAmB,CAEnB,oBAEF","sourcesContent":[".link {\n  font-size: 0.875rem;\n  color: var(--font-color);\n  line-height: 1.125rem;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "TableCellLink__link__1fHz5"
};
export default ___CSS_LOADER_EXPORT___;
